<template>
  <v-app id="inspire" class="bodyPadding productsalesScreen"> 
    <mo-header></mo-header>
    <v-content>
		<ps-head></ps-head>		
		<ps-list></ps-list>
    </v-content>
  </v-app>
</template>

<script>

	import PsHead from './Header.vue';	
	import PsList from './List.vue';
	export default {
		data () {
			return {
		
			}		
		},
		components: {
			PsHead,
			PsList
		}
	}
</script>

<style scoped>
	@import '../../shared/assets/css/shared.css'
</style>